import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Md5} from "ts-md5/dist/md5";

/**
 * Api is a generic REST Api handler. Set your API url first.
 */


@Injectable()
export class ApiService {


  // url: string = 'http://www.overdose.com';       // 本地测试
  // url: string = 'http://overdose.jmj.tp13.com';  // 测试
  url: string = 'http://v2.tp13.com';

  key: string = 'whatafuckingday!';
  public token = '';
  version: string = '1.9';



  constructor(public http: HttpClient) {
  }

    private indexOf(array,val) {
        for (let i = 0; i < array.length; i++) {
            if (array[i] == val) return i;
        }
        return -1;
    };

  get(endpoint: string, params?: any, reqOpts?: any)
  {

    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }
    // Support easy query params for GET requests
    if (params) {
      if (params.hasOwnProperty('user_id'))
      {
        if(params.user_id == 0)
        {
            delete params.user_id
        }

        params.token = this.token;
      }
      //加入固定参数
      let timestamp: number = (new Date()).valueOf();
      timestamp = Math.round(timestamp / 1000);
      params.app_version = this.version;
      params.t = timestamp;
      //
      reqOpts.params = new HttpParams();
      for (let k in params)
      {

        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
      let s = this.getsign(params);
      reqOpts.params = reqOpts.params.set('sign', s);

    }
    console.log('get:' + this.url + '/' + endpoint);
      if(endpoint.substr(0, 4) != 'http')
      {
          endpoint = this.url + '/' + endpoint;
      }
    return this.http.get(endpoint, reqOpts);
  }

  localget(endpoint: string) {
    return this.http.get(endpoint);
  }

  getparamstr(params?: any) {

    let str: string = '';
    if (params) {
      let keys: string[] = [];
      for (let k in params) {
        keys.push(k);
      }
      keys.sort();
      for (let x in keys) {
        keys[x] = keys[x] + '=' + params[keys[x]];
      }
      console.log(keys);
      str = keys.join('&');
    }
    return str;
  }

  public getsign(params?: any) {
    let sign: string = '';
    sign = this.getparamstr(params) + '&key=' + this.key;
    sign = Md5.hashStr(sign).toString().toUpperCase();
    // console.log(sign);
    return sign;
  }

  post(endpoint: string, body: any, options?: any) {
    if (body) {
      if (body.hasOwnProperty('user_id')) {
          if(body.user_id == 0)
          {
              delete body.user_id
          }
        body.token = this.token;
      }
      //加入固定参数
      let timestamp: number = (new Date()).valueOf();
      timestamp = Math.round(timestamp / 1000);
      body.app_version = this.version;
      body.t = timestamp;
    }
    body.sign = this.getsign(body);
    console.log('post:' + this.url + '/' + endpoint);

    if(endpoint.substr(0, 4) != 'http')
    {
        endpoint = this.url + '/' + endpoint;
    }
    return this.http.post(endpoint, body, options);
  }

  put(endpoint: string, body: any, options?: any) {
    if (body) {
      if (body.hasOwnProperty('user_id')) {
          if(body.user_id == 0)
          {
              delete body.user_id
          }
        body.token = this.token;
      }
      //加入固定参数
      let timestamp: number = (new Date()).valueOf();
      timestamp = Math.round(timestamp / 1000);
      body.app_version = this.version;
      body.t = timestamp;
    }
    body.sign = this.getsign(body);
    console.log('put:' + this.url + '/' + endpoint);
    return this.http.put(this.url + '/' + endpoint, body, options);
  }

  delete(endpoint: string, params?: any, options?: any) {
    if (!options) {
      options = {
        params: new HttpParams()
      };
    }
    if (params) {
      if (params.hasOwnProperty('user_id')) {
          if(params.user_id == 0)
          {
              delete params.user_id
          }
        params.token = this.token;
      }
      //加入固定参数
      let timestamp: number = (new Date()).valueOf();
      timestamp = Math.round(timestamp / 1000);
      params.app_version = this.version;
      params.t = timestamp;
      //
      options.params = new HttpParams();
      for (let k in params) {
        options.params = options.params.set(k, params[k]);
      }
      let s = this.getsign(params);
      options.params = options.params.set('sign', s);

    }
    console.log('delete:' + this.url + '/' + endpoint);
    return this.http.delete(this.url + '/' + endpoint, options);
  }

  patch(endpoint: string, body: any, options?: any) {
    return this.http.put(this.url + '/' + endpoint, body, options);
  }
}



// WEBPACK FOOTER //
// ./src/providers/api-service/api-service.ts